import { useCallback, useEffect, useState } from "react";
import { IError } from "itsf-ui-common";
import { IHpp } from "../IStancerPayment";
import { PAYMENT_STANCER_URL } from "@constants";
import { useFetch } from "@hooks/useFetch";

interface IParams {
    paymentIntentId: IHpp["paymentIntentId"];
    validatePaymentApiRoute: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const useStancer3dsIframe = (props: IParams) => {
    const { paymentIntentId, validatePaymentApiRoute, successCallback } = props;
    const [iframeFetchState, { post }] = useFetch();
    const [iframeKey, setIframeKey] = useState(0);

    const submitPayment = useCallback(
        (event: MessageEvent) => {
            if (event.origin !== PAYMENT_STANCER_URL) {
                return;
            }

            if (event.data.status !== "finished") {
                return;
            }

            post(validatePaymentApiRoute, {
                body: { paymentIntentId },
                forwardError: true,
            })
                .then(successCallback)
                .catch(() => setIframeKey((prevState) => prevState + 1));
        },
        [paymentIntentId, post, successCallback, validatePaymentApiRoute]
    );

    useEffect(() => {
        window.addEventListener("message", submitPayment, false);

        return () => window.removeEventListener("message", submitPayment);
    }, [submitPayment]);

    return {
        iframeFetchState,
        iframeKey,
        submitPayment,
    };
};
